import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const analyzeInstitution = async ({
  filters,
  indicators,
  order_by,
  order_direction,
  page = 0,
  page_size = 2000,
}) => {
  const axios = AxiosConfigExplore();
  const url = "/benchmarking/institution/analyze";

  const payload = {
    filters: {
      location: filters?.location || [],
      time_span:
        typeof filters?.time_span === "number" ? filters.time_span : null,
    },
    indicators: indicators || [],
    page,
    page_size,
    order_by,
    order_direction,
  };

  const res = await axios.post(url, payload);
  return res.data;
};

/**
 * Lấy phân bố 17 SDG cho Institution trong Benchmarking / Overview.
 * GET /explore/benchmarking/institution/social_impact
 *
 * @param {Object} params
 * @param {string} params.entity_id - ID hoặc explore slug của trường/viện
 * @param {string} [params.year_range="last_5_years"] - "all" | "last_5_years" | "last_10_years"
 * @param {string[]|string} [params.subject_area] - Tối đa 1 keyword
 * @param {AbortSignal} [signal]
 */
export const getBenchmarkingSocialImpact = async (params, signal) => {
  const axios = AxiosConfigExplore();
  const res = await axios.get("/benchmarking/institution/social_impact", {
    params,
    signal,
  });
  return res.data;
};

/**
 * Lấy chi tiết 1 SDG cho Institution (Drawer).
 * GET /explore/benchmarking/institution/social_impact/{sdg_num}
 *
 * @param {number|string} sdgNum
 * @param {Object} params
 * @param {string} params.entity_id - ID hoặc explore slug của trường/viện
 * @param {string} [params.year_range="last_5_years"] - "all" | "last_5_years" | "last_10_years"
 * @param {string[]|string} [params.subject_area] - Tối đa 1 keyword
 * @param {AbortSignal} [signal]
 */
export const getBenchmarkingSocialImpactDetail = async (sdgNum, params, signal) => {
  const axios = AxiosConfigExplore();
  const res = await axios.get(`/benchmarking/institution/social_impact/${sdgNum}`, {
    params,
    signal,
  });
  return res.data;
};

